(() => {
  const selector = 'img[data-card-image="native"]';
  const markReady = image => {
    if (image.complete && image.naturalWidth > 0) {
      if (image.getAttribute('data-card-image-ready') !== 'true') image.setAttribute('data-card-image-ready', 'true');
    }
  };
  const recover = image => {
    const fallback = image.getAttribute('data-card-image-fallback');
    if (!fallback || image.hasAttribute('data-card-image-retried')) return;
    image.setAttribute('data-card-image-retried', 'true');
    image.removeAttribute('data-card-image-ready');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = fallback;
  };
  document.addEventListener('error', event => {
    if (event.target instanceof HTMLImageElement && event.target.matches(selector)) {
      recover(event.target);
    }
  }, true);
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLImageElement && event.target.matches(selector)) {
      markReady(event.target);
    }
  }, true);
  const check = (scope = document) => {
    const images = Array.from(scope.querySelectorAll(selector));
    if (scope.matches?.(selector)) images.unshift(scope);
    images.forEach(image => {
    if (image.complete && image.naturalWidth === 0) recover(image);
    else markReady(image);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => check(), { once: true });
  } else {
    check();
  }
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) check(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
